/**
 * GiftCardsErrorBanner — a failed load, shown rather than swallowed into an
 * empty list/detail (BON-223). Shared between the list and detail pages.
 */
export function GiftCardsErrorBanner({ message }: { message: string }) {
  return (
    <div
      role="alert"
      className="nb-card nb-card-tight"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: 16,
        borderLeft: '3px solid var(--nb-warn)',
      }}
    >
      <span style={{ fontSize: 13, color: 'var(--nb-ink-2)' }}>{message}</span>
    </div>
  );
}
